import { useCallback } from 'react';
import Button from '@paradigm/design-system/src/components/Button';
import CopyIcon from '@paradigm/design-system/src/assets/CopyIcon';
import {
  useRfqBuilderActions,
  useRfqBuilderLegView,
} from '@paradigm/features/src/unified-rfqs/ui';

export default function DuplicateLegButton() {
  const { index } = useRfqBuilderLegView();
  const { duplicateLeg } = useRfqBuilderActions();

  const handleClick = useCallback(() => {
    duplicateLeg(index);
  }, [index, duplicateLeg]);

  return (
    <Button
      onClick={handleClick}
      ariaLabel="Duplicate Leg"
      variant="link"
      theme="secondary-dark-blue"
    >
      <CopyIcon size={14} />
    </Button>
  );
}
